module.exports = __webpack_public_path__ + "img/yuanxiao.b1254bc6.png";